import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { api } from './services'

import { VueMaskDirective } from 'v-mask'

Vue.directive('mask', VueMaskDirective)

Vue.config.productionTip = false

if (store.state.token !== undefined) {
  api.defaults.headers.common.Authorization = `Bearer ${store.state.token}`
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
